module.exports = __webpack_public_path__ + "img/ueber-mich_1280.f30b08f4.webp";